import { Box } from "@mui/material";
import React from "react";
import "./crm-price-details.scss";
import { TextInputComponent } from "../../../../../common/components";
import { Form, Formik, useFormikContext } from "formik";
import icons from "../../../../../assets/icons/icons";

interface CRMPriceDetailsProps {
  mode?: string;
  handleCancel?: any;
  handleSubmit?: (
    sectionType: "basicDetails" | "pricing" | "benefits",
    payload: any,
    updatePlansData: any
  ) => void;
}
const CRMPriceDetails: React.FC<CRMPriceDetailsProps> = ({
  mode,
  handleCancel,
  handleSubmit,
}) => {
  const { values, errors, touched, validateField, handleChange, setFieldTouched } =
    useFormikContext<any>();

  const onSubmit = () => {
    // If either price is empty, show error and do not submit
    let hasError = false;
    if (!values?.monthlyPrice) {
      validateField("monthlyPrice");
      setFieldTouched("monthlyPrice", true);
      hasError = true;
    }
    if (!values?.annualPrice) {
      validateField("annualPrice");
      setFieldTouched("annualPrice", true);
      hasError = true;
    }
    if (hasError) return;

    const payload = {
      monthlyPrice: values?.monthlyPrice,
      annualPrice: values?.annualPrice,
      // planCategory: values?.planCategory.toLowerCase(),
    };

    if (handleSubmit) handleSubmit("pricing", payload, payload);
  };

  return (
    <Box className="price-details-wrapper">
      <p className="price-header">Pricing</p>
      <Box className="form-input-wrapper ">
        <Box className="price-input-wrapper">
          <p>Monthly</p>
          <Box className="price-input-wrapper" gap={1}>
            <p className="input-doller">$</p>
            <TextInputComponent
              type="text"
              fieldName="monthlyPrice"
              onChange={handleChange}
              placeholder="Enter Value"
              value={values?.monthlyPrice || ""}
              isDecimal={true}
              beforeDecimalMaxLength={7}
              afterDecimalMaxLength={2}
            />
            {/* <img src={icons.GreenTick} />
                  <img src={icons.DeleteRed} height={18} /> */}
          </Box>
        </Box>
        <Box className="price-input-wrapper">
          <p>Yearly</p>
          <Box className="price-input-wrapper" gap={1}>
            <p className="input-doller">$</p>
            <TextInputComponent
              type="text"
              fieldName="annualPrice"
              onChange={handleChange}
              placeholder="Enter Value"
              variant="standard"
              value={values?.annualPrice || ""}
              isDecimal={true}
              beforeDecimalMaxLength={7}
              afterDecimalMaxLength={2}
            />
            {/* <img src={icons.GreenTick} />
                <img src={icons.DeleteRed} height={18} /> */}
          </Box>
        </Box>
        {mode === "edit" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              paddingBottom: "20px",
              marginTop: "30px",
            }}
          >
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              onClick={onSubmit}
              type="button"
              className="cancel-button next-button-wrapper"
            >
              Save
            </button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CRMPriceDetails;
